module.exports = __webpack_public_path__ + "/static/assets/8e7773f07ca322885d44b637e1e4eb21.png";